<template>
  <div class="IconElement" :title="value1" style="width: 50px">
    <i class="el-icon-circle-close i-close-class" @click="iconClear" v-show="canClear"></i>
    <div class="i-reference" @click="selectIcon">
      <i :class="value1" v-if="value1 !== ''"></i>
      <i class="el-icon-plus" v-else></i>
    </div>
    <el-popover placement="bottom" v-model="mod" width="450px" trigger="click">
      <div class="iconList">
        <i v-for="item in iconList" :key="item" :class="item" @click="setIcon(item)" style="font-size:20px"></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { elementIcons } from '../../assets/js/Icon'
export default {
  name: 'IconElement',
  props: ['mProp', 'mObj', 'mReadOnly', 'mClearAble'],
  data () {
    return {
      iconList: {},
      mod: false
    }
  },
  components: {
  },
  computed: {
    value1 () {
      if ((this.mObj) && (this.mObj[this.mProp])) {
        return this.mObj[this.mProp]
      } else {
        return ''
      }
    },
    canClear () {
      if (this.mReadOnly) {
        return false
      } else if (this.mObj[this.mProp] === '') {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.iconList = elementIcons
  },
  methods: {
    setIcon (icon) {
      this.mObj[this.mProp] = icon
      this.mod = false
    },
    iconClear () {
      if ((!this.mReadOnly) && (this.mClearAble)) {
        this.mObj[this.mProp] = ''
      }
    },
    selectIcon () {
      if ((!this.mReadOnly) && (this.mClearAble)) {
        this.mod = !this.mod
      }
    }
  },
  beforeMount () {
  },
  mounted () {
    document.addEventListener('click', e => {
      if (!this.$el.contains(e.target)) {
        this.mod = false
      }
    })
  }
}
</script>

<style lang="less" scoped>
.iconList{
  width: 400px;
  height: 300px;
  overflow-y: scroll;//y轴显示滚动条
  overflow-x: hidden;//x轴溢出隐藏
  display: flex;
  flex-wrap: wrap;//换行
  justify-content: space-around;
  i{
    display: inline-block;
    width: 30px;
    height: 30px;
    color: #000000;
    font-size: 15px;
    //border: 1px solid #E6E6E6;
    //border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 30px;
    margin: 5px ;
    &:hover{
      color: deepskyblue;
      //border-color: cadetblue;
    }
  }
}
.i-close-class {
  float: right;
  cursor: pointer
}
.i-reference {
  width: 35px;
  height: 30px;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  font-size: 15px;
  cursor: pointer
}
</style>
